import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { Timestamp } from '@1amageek/ballcap';
import { useAlert, types } from 'react-alert';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { ConfirmDialog, LinkText, PageTitle, PaperWithTitle, PrimaryButton } from '../../../components';
import { getLabelReward, getLabelWorkingDate } from '../../../common/helper';
import { useMaster, usePayment } from '../../../../model/hooks';
import { useChangeEvent } from '../../../../model/hooks/common/ChangeEventHooks';
export const PaymentConfirm = () => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const reactAlert = useAlert();
    const { master } = useMaster();
    const { loadWithholdingAmount, payRewardToWorker, loadingPayReward } = usePayment();
    const { changeText } = useChangeEvent();
    // 一覧からの遷移ではない場合は一覧にとばす
    if (!location.state)
        history.replace('/home/payment');
    let jobReward = null;
    let id = '';
    if (location.state) {
        jobReward = location.state.jobReward;
        id = location.state.id;
    }
    const [rewardAmount, setRewardAmount] = useState('');
    const [calculatedRewardAmount, setCalculatedRewardAmount] = useState('-');
    const [calculatedWithholding, setCalculatedWithholding] = useState('-');
    const [calculatedPaymentAmount, setCalculatedPaymentAmount] = useState('-');
    const [amount, setAmount] = useState('');
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
    const onClickJobTitle = () => { var _a; return history.push(`/home/job_offer/detail/${(_a = jobReward) === null || _a === void 0 ? void 0 : _a.jobOfferId}`); };
    const onClickCalcWithholding = () => {
        if (rewardAmount === '')
            return;
        const rewardNum = parseInt(rewardAmount, 10);
        const withholding = loadWithholdingAmount(rewardNum);
        setCalculatedRewardAmount(rewardAmount);
        setCalculatedWithholding(`${withholding}`);
        setCalculatedPaymentAmount(`${rewardNum - withholding}`);
        setAmount(`${rewardNum - withholding}`);
    };
    const onClickConfirm = async () => {
        if (!amount) {
            reactAlert.show(t('支払い額を入力してください'), { type: types.ERROR });
            return;
        }
        try {
            await payRewardToWorker(id, parseInt(amount, 10));
            reactAlert.show(t('支払い処理が完了しました'), { type: types.SUCCESS });
            history.push('/home/payment');
        }
        catch (e) {
            if (e instanceof Error)
                reactAlert.show(e.message, { type: types.ERROR });
        }
    };
    const onOpenDialog = () => setIsOpenConfirmDialog(true);
    const onCloseDialog = () => setIsOpenConfirmDialog(false);
    return (React.createElement(React.Fragment, null, jobReward && (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('支払い額の確定')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(PaperWithTitle, { title: "\u652F\u6255\u3044\u984D\u306E\u78BA\u5B9A", titleAlign: "center" },
                    React.createElement(SContainer, null,
                        React.createElement(SDl, null,
                            React.createElement("dt", null, t('業務内容')),
                            React.createElement("dd", null,
                                React.createElement(LinkText, { size: "16px", onClick: onClickJobTitle }, jobReward.jobTitle)),
                            React.createElement("dt", null, t('ワーカー')),
                            React.createElement("dd", null, `${jobReward.workerLastName} ${jobReward.workerFirstName}`),
                            React.createElement("dt", null, t('日付')),
                            React.createElement("dd", null, jobReward.startWorkingTimePerDay && jobReward.endWorkingTimePerDay && (React.createElement(React.Fragment, null, getLabelWorkingDate(jobReward.employmentId, new Timestamp((_a = jobReward.startWorkingTimePerDay) === null || _a === void 0 ? void 0 : _a.seconds, (_b = jobReward.startWorkingTimePerDay) === null || _b === void 0 ? void 0 : _b.nanoseconds), new Timestamp((_c = jobReward.endWorkingTimePerDay) === null || _c === void 0 ? void 0 : _c.seconds, (_d = jobReward.endWorkingTimePerDay) === null || _d === void 0 ? void 0 : _d.nanoseconds))))),
                            React.createElement("dt", null, t('報酬')),
                            master && (React.createElement("dd", null, getLabelReward(master.rewardTypeList, jobReward.rewardTypeId, jobReward.rewardAmount))),
                            React.createElement("dt", null, t('源泉徴収額の計算')),
                            React.createElement("dd", { style: { marginLeft: 0, marginBottom: '16px' } },
                                React.createElement(STextField, { required: true, value: rewardAmount, variant: "outlined", size: "small", type: "number", style: { marginRight: '16px' }, onChange: changeText(setRewardAmount) }),
                                React.createElement(PrimaryButton, { disabled: rewardAmount === '', onClick: onClickCalcWithholding }, t('源泉徴収額の計算'))),
                            React.createElement(SRow, null,
                                React.createElement(SCalcArea, null,
                                    React.createElement(SCalcTitle, null, t('報酬合計金額')),
                                    React.createElement("p", null, calculatedRewardAmount)),
                                React.createElement(SCalcArea, null,
                                    React.createElement(SCalcTitle, null, t('源泉徴収額')),
                                    React.createElement("p", null, calculatedWithholding)),
                                React.createElement(SCalcArea, null,
                                    React.createElement(SCalcTitle, null, t('予想される支払い額')),
                                    React.createElement("p", null, calculatedPaymentAmount))),
                            React.createElement("dt", { style: { marginTop: '32px' } }, t('実際の確定支払い額を入力')),
                            React.createElement("dd", { style: { marginLeft: 0 } },
                                React.createElement(STextField, { required: true, value: amount, variant: "outlined", size: "small", fullWidth: true, type: "number", onChange: changeText(setAmount) }))),
                        React.createElement(Grid, { container: true, justify: "center" },
                            React.createElement(Grid, { item: true, xs: 11, md: 6, style: { marginTop: '40px' } },
                                React.createElement(PrimaryButton, { disabled: amount === '', onClick: onOpenDialog, fullWidth: true }, t('確定')))))))),
        React.createElement(ConfirmDialog, { isOpen: isOpenConfirmDialog, title: t('支払い額の確定'), negativeLabel: t('キャンセル'), positiveLabel: t('確定'), onClose: onCloseDialog, onClickNegative: onCloseDialog, onClickPositive: onClickConfirm, loading: loadingPayReward, isCancel: true },
            React.createElement("p", null, "\u652F\u6255\u3044\u984D\u3092\u78BA\u5B9A\u3057\u307E\u3059\u304B\uFF1F"))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SContainer = styled.div `
  padding: 32px;
`;
const SDl = styled.dl `
  dt {
    font-weight: bold;
    margin-bottom: 16px;
  }
  dd {
    margin-bottom: 32px;
  }
`;
const STextField = styled(TextField) `
  &&& {
    label {
      font-size: 18px;
    }
  }
`;
const SRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
const SCalcArea = styled.div `
  text-align: center;
`;
const SCalcTitle = styled.p `
  margin: 0;
  font-size: 14px;
  font-weight: bold;
`;
